import classNames from 'classnames';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { MobileActivityInput } from '../../ActivityInput/mobile/MobileActivityInput';
import { MobileLocationInput } from '../../LocationInput/mobile/MobileLocationInput';
import { useSearch } from '../use-search';
import { SmallSpinner } from '../../../decorators/spinner';
import { ArrowStylizedLg } from '../../../icons';

export const MobileSearchForm = () => {
  const {
    defaultActivity,
    defaultLocation,
    currentLocale,
    handleSubmit,
    activityValue,
    setActivityValue,
    locationValue,
    setLocationValue,
    activeInput,
    setActiveInput,
    setValidateActivity,
    setValidateLocation,
    mobileTrayViewValue,
    fetchingGeoData
  } = useSearch();

  const isValueDoneLoading = (isDone) => {
    setLocationDoneLoading(isDone);
  };

  return (
    <form className="search_form flex column flex-one" onSubmit={handleSubmit}>
      <div className="relative ph-sm flex column flex-one">
        <MobileActivityInput
          value={activityValue}
          setValue={setActivityValue}
          defaultActivity={defaultActivity}
          formActive={false}
          activeInput={activeInput}
          setActiveInput={setActiveInput}
          setValidator={setValidateActivity}
          noHighlight
        />
        <MobileLocationInput
          value={locationValue}
          setValue={setLocationValue}
          defaultLocation={defaultLocation}
          formActive={false}
          currentLocale={currentLocale}
          activeInput={activeInput}
          setActiveInput={setActiveInput}
          setValidator={setValidateLocation}
          isValueDoneLoading={isValueDoneLoading}
          noHighlight
        />
        {
          'main' === mobileTrayViewValue && (
            <div className="flex middle responsive-padding padding-lg-bottom" style={{ marginTop: 'auto' }}>
              <button className="btn btn-primary relative w-100 searchBtn" disabled={fetchingGeoData}>
                <div className={`flex middle center ${!fetchingGeoData ? 'visible' : 'invisible'}`}>
                  <FormattedMessage
                    id="shared_components.search-form.search"
                    defaultMessage="Search"
                  />
                  <ArrowStylizedLg style={{ fontSize: '24px' }} className="margin-md-left" />
                </div>
                <div className={`flex middle center ${fetchingGeoData ? 'visible' : 'invisible'}`}>
                  <SmallSpinner show />
                </div>
              </button>
            </div>

          )
        }
      </div>
    </form>
  );
};
